
import { Component, Vue, Prop } from 'vue-property-decorator';
import { JobDetailedData } from '@/models/jobDetailed';
import ChooseAddressStopFieldset from '@/components/fieldsets/ChooseAddressStopFieldset.vue';

@Component({
  components: {
    ChooseAddressStopFieldset,
  },
})
export default class ChooseAddressFieldset extends Vue {
  @Prop(Object) public value: JobDetailedData;
  @Prop(Boolean) public loading: boolean;
  @Prop(Boolean) public disabled: boolean;

  get detailedJob() {
    return this.value;
  }

  set detailedJob(value) {
    this.$emit('input', value);
  }
}
